import {useEffect, useState} from "react";
import {BASE_URL} from "../services/api";
import api from "../services/instanceapi";
import {imgConfig} from "../services/imgConfig";
import {getImage} from "../utils/utils";

const useImageChange = (id, initialImage, defaultPicture, name) => {
    /* This hook is used for image changing :
    * Some of entity has image (user, strategy,axis) and we have
    * to go through this process before send it to the back */

    const [imageSize, setImageSize] = useState("")
    const [lengthError, setLengthError] = useState(false)
    const [image, setImage] = useState(null)
    const IMG_URL = `${BASE_URL}${name}/${id}/image`

    useEffect(() => {
        setImage(getImage(initialImage, defaultPicture))
    }, [defaultPicture, initialImage])

    const returnImageSize = (e) => {
        const oneMegaByte = 1000000
        const suffixes = ['O', 'ko', 'Mo', 'Go', 'To'];
        const i = Math.floor(Math.log(e.target.files[0].size) / Math.log(1024));
        const size = `${(e.target.files[0].size / Math.pow(1024, i)).toFixed(2)} ${suffixes[i]}`
        let sizeObj = {size: size}
        if (e.target.files && e.target.files[0]) {
            if (e.target.files[0].size > oneMegaByte) {
                //   setLengthError(true)
                let resObj = {res: false}
                return {...sizeObj, ...resObj}
            } else {
                let img = e.target.files[0];
                let imgObj = {img: URL.createObjectURL(img)}
                return {res: img, ...imgObj, ...sizeObj}
            }
        }
    }

    const returnConfigImageForPost = async (img) => {
        let data = new FormData()
        data.append('file', img)
        return data
    }

    const onImageChange = async (e) => {
        const res = returnImageSize(e)
        setImageSize(res.size)
        if (res.res === false) {
            setLengthError(true)
        } else {
            const image = res.img
            setImage(image)
            let img = await returnConfigImageForPost(res.res)
            await api.post(IMG_URL, img, imgConfig)
        }
    }

    const onImageDelete = async () => {
        await api.delete(IMG_URL)
        setImage(null)
        setImageSize("")
        setLengthError(false)
    }
    return {imageSize, lengthError, image, onImageChange, onImageDelete}
}

export default useImageChange